module.exports = __webpack_public_path__ + "49323c5b9a440ff75d26b90859919a8e.svg";